export const getConversionLabel = (conversion) => {
    const name = conversion?.name ?? conversion?.conversion_name ?? "";
    const id = conversion?.id ?? conversion?.conversion_id ?? "";
    return id ? `${name} - ${id}` : name;
};

export const normalizeAutoMatchedEvents = (autoMatchedEvents = []) =>
    (autoMatchedEvents ?? [])
        .map((item) => ({
            event: String(item?.code ?? item?.event ?? ""),
            conversion_id: String(
                item?.conversion?.id ?? item?.conversion_id ?? "",
            ),
            conversion_name:
                item?.conversion?.name ?? item?.conversion_name ?? "",
            isCustom: item?.is_custom === true,
            event_type: item?.conversion?.event_type ?? item?.event_type ?? "",
            custom_event_name:
                item?.conversion?.custom_event_name ??
                item?.custom_event_name ??
                null,
        }))
        .filter((mapping) => mapping.event && mapping.conversion_id);

export const mapStoredOpenAiMappings = (mappings = []) =>
    (mappings ?? []).map((mapping) => ({
        conversion_id: mapping.conversion_id?.toString() ?? "",
        conversion_name: mapping.conversion_name || "",
        event: mapping.event?.toString() ?? "",
        isCustom: mapping.is_custom === true,
        event_type: mapping.event_type ?? "",
        custom_event_name: mapping.custom_event_name ?? null,
    }));

export const isValidOpenAiMapping = (mapping, conversions = []) => {
    const event = String(mapping?.event ?? "").trim();
    const conversionId = String(mapping?.conversion_id ?? "").trim();

    if (!event || !conversionId) return false;

    return conversions.some(
        (conversion) => conversion?.id?.toString() === conversionId,
    );
};

export const areOpenAiMappingsValid = (mappings = [], conversions = []) => {
    if (!mappings?.length) return true;
    if (!conversions?.length) return false;

    return mappings.every((mapping) =>
        isValidOpenAiMapping(mapping, conversions),
    );
};

export const buildOpenAiMappingsPayload = (
    mappings = [],
    conversions = [],
) => ({
    mappings: (mappings ?? []).map((mapping) => {
        const conversion = (conversions ?? []).find(
            (item) =>
                item?.id?.toString() === mapping?.conversion_id?.toString(),
        );
        const eventType = String(
            conversion?.event_type ?? mapping?.event_type ?? "",
        );
        const row = {
            event: mapping.event?.toString(),
            conversion_id: mapping.conversion_id?.toString(),
            conversion_name:
                mapping.conversion_name ||
                conversion?.name ||
                conversion?.conversion_name ||
                "",
            event_type: eventType,
        };

        if (eventType === "custom") {
            row.custom_event_name =
                conversion?.custom_event_name ??
                mapping?.custom_event_name ??
                null;
        }

        return row;
    }),
});
